import React from 'react'
import { connect } from 'react-redux'
import { getUserInfo } from 'modules/organization'
import { defineRavensdownRules } from 'abilities/common'
import { Can } from '@casl/react'

import { Dashboard } from 'components/main/Dashboard'
import MainContainer from 'components/main/MainContainer'
import { Dashboard as RavensdownDashboard } from 'components/ravensdown/Dashboard'

const Main = ({ userInfo }) => {
  const ravensdownAbility = defineRavensdownRules(userInfo)

  return (
    <Can I="manage" on="Ravensdown" ability={ravensdownAbility} passThrough>
      {(allowed) =>
        allowed ? (
          <RavensdownDashboard />
        ) : (
          <MainContainer>
            <Dashboard />
          </MainContainer>
        )
      }
    </Can>
  )
}

const Connected = connect((state) => ({
  userInfo: getUserInfo(state),
}))(Main)

export default Connected
